import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaArrowLeft,
  FaChevronDown,
  FaMobileAlt,
  FaCheckCircle,
  FaClock,
  FaWallet
} from "react-icons/fa";

import "./DepositTzMobile.css";

export default function TanzaniaDeposit() {
  const navigate = useNavigate();

  const [message, setMessage] = useState("");
  const [amount, setAmount] = useState("");
  const [provider, setProvider] = useState("");

  const [showMethods, setShowMethods] = useState(false);
  const [showHint, setShowHint] = useState(false);

  const methods = [
    "Vodacom (M-Pesa)",
    "Airtel Money",
    "Yas (Tigo Pesa)",
    "Halotel Money"
  ];

  /* =====================================================
     SHOW BANNER
  ===================================================== */

  const showBanner = (text) => {
    setMessage(text);

    setTimeout(() => {
      setMessage("");
    }, 3000);
  };


  /* =====================================================
     FORMAT AMOUNT
  ===================================================== */

  const formatAmount = (value) => {
    if (!value) return "";

    const number = Number(value);

    if (Number.isNaN(number)) return value;

    return number.toLocaleString("en-US");
  };


  /* =====================================================
     HANDLE AMOUNT
  ===================================================== */

  const handleAmountChange = (e) => {
    const value = e.target.value;

    // Ruhusu input tupu
    if (value === "") {
      setAmount("");
      return;
    }

    // Ondoa decimals
    const cleanValue = value.replace(/\D/g, "");

    setAmount(cleanValue);
  };


  /* =====================================================
     HANDLE DEPOSIT
  ===================================================== */

  const handleDeposit = () => {
    const depositAmount = Number(amount);

    /* -----------------------------------------------
       AMOUNT
    ------------------------------------------------ */

    if (!amount) {
      showBanner("Please enter deposit amount");
      return;
    }


    /* -----------------------------------------------
       MINIMUM
    ------------------------------------------------ */

    if (depositAmount < 10000) {
      showBanner("Minimum deposit amount is 10,000 TZS");
      return;
    }


    /* -----------------------------------------------
       MAXIMUM
    ------------------------------------------------ */

    if (depositAmount > 5000000) {
      showBanner("Maximum deposit amount is 5,000,000 TZS");
      return;
    }


    /* -----------------------------------------------
       PAYMENT METHOD
    ------------------------------------------------ */

    if (!provider) {
      setShowHint(true);
      setShowMethods(true);

      setTimeout(() => {
        setShowHint(false);
      }, 3000);

      return;
    }


    /* -----------------------------------------------
       GO TO MOBILE PAYMENT
    ------------------------------------------------ */

    navigate("/mobile-payment", {
      state: {
        amount: depositAmount,
        provider: provider
      }
    });
  };


  /* =====================================================
     SELECT PAYMENT METHOD
  ===================================================== */

  const selectProvider = (item) => {
    setProvider(item);
    setShowMethods(false);
    setShowHint(false);
  };


  /* =====================================================
     RENDER
  ===================================================== */

  return (
    <div className="tz-page">

      {/* =================================================
          BANNER
      ================================================= */}

      {message && (
        <div className="banner-message">
          {message}
        </div>
      )}


      {/* =================================================
          HEADER
      ================================================= */}

      <div className="tz-header">

        <button
          type="button"
          className="back"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <FaArrowLeft />
        </button>

        <div>
          <h2>Tanzania Deposit</h2>
        </div>

      </div>


      {/* =================================================
          TABS
      ================================================= */}

      <div className="buy-sell">

        <button
          type="button"
          className="active"
        >
          Deposit
        </button>

        <button
          type="button"
          onClick={() => {
            showBanner("Withdraw page coming soon");
          }}
        >
          Withdraw
        </button>

      </div>


      {/* =================================================
          AMOUNT CARD
      ================================================= */}

      <div className="input-box">

        <label>
          Enter Amount
        </label>


        <div className="amount-row">

          <input
            type="number"
            inputMode="numeric"
            placeholder="0"
            value={amount}
            onChange={handleAmountChange}
            min="10000"
            max="5000000"
            aria-label="Deposit amount"
          />


          <div className="currency">
            🇹🇿 TZS
          </div>

        </div>


        {/* ===============================================
            RANGE
        ================================================ */}

        <div className="deposit-range">

          <div className="range-line"></div>

          <div className="range-text">
            10,000 - 5,000,000 TZS
          </div>

        </div>

      </div>


      {/* =================================================
          PAYMENT METHOD
      ================================================= */}

      <div
        className={`provider-box ${
          showHint ? "shake" : ""
        }`}
        onClick={() => {

          setShowMethods(!showMethods);

          setShowHint(false);

        }}
      >

        <div className="provider-content">

          <div className="provider-icon">
            <FaMobileAlt />
          </div>

          <div>

            <h3>
              Payment Method
            </h3>

            <p>
              {provider || "Select Mobile Money"}
            </p>

          </div>

        </div>


        <FaChevronDown
          className={
            showMethods
              ? "chevron-open"
              : ""
          }
        />

      </div>


      {/* =================================================
          SELECT HINT
      ================================================= */}

      {showHint && (
        <div className="select-hint">
          👉 Please select Payment Method first 🔥👇
        </div>
      )}


      {/* =================================================
          METHOD LIST
      ================================================= */}

      {showMethods && (

        <div className="method-list">

          {methods.map((item, index) => (

            <div
              key={index}
              className={`method-item ${
                provider === item
                  ? "selected-method"
                  : ""
              }`}
              onClick={() => selectProvider(item)}
            >

              <div className="method-left">

                <div className="method-icon">
                  <FaMobileAlt />
                </div>

                <span>
                  {item}
                </span>

              </div>


              {provider === item && (
                <FaCheckCircle className="method-check" />
              )}

            </div>

          ))}

        </div>

      )}


      {/* =================================================
          INFO BOX
      ================================================= */}

      <div className="info-box">

        <div>

          <span className="info-label">
            <FaCheckCircle />
            Fee
          </span>

          <span className="info-value success">
            0%
          </span>

        </div>


        <div>

          <span className="info-label">
            <FaClock />
            Processing Time
          </span>

          <span className="info-value processing">
            Instant
          </span>

        </div>


        <div>

          <span className="info-label">
            <FaWallet />
            Receive
          </span>

          <span className="info-value">
            Wallet Balance
          </span>

        </div>

      </div>


      {/* =================================================
          DEPOSIT BUTTON
      ================================================= */}

      <button
        type="button"
        className="deposit-btn"
        onClick={handleDeposit}
      >
        Deposit Now
      </button>


    </div>
  );
}
